// Module
var code = "<student-assignments-list-v2></student-assignments-list-v2> ";
// Exports
module.exports = code;